import { GenericAction } from './actions';

export function createReducer<T>(initialState: T) {
  return function reducer(state: T, action: GenericAction<T>): T {
    switch (action.type) {
      case 'SET_FIELD':
        return { ...state, [action.payload.field]: action.payload.value };

case 'ADD_ARRAY_ITEM': {
  const current = Array.isArray(state[action.payload.field])
    ? (state[action.payload.field] as unknown[] || [])
    : [];

  const newArray =
    current.length > 0
      ? [
          ...current.slice(0, -1),           // everything except last
          action.payload.item,              // new item
          current[current.length - 1],      // last item stays last
        ]
      : [action.payload.item]; // if empty, just add

  return {
    ...state,
    [action.payload.field]: newArray,
  };
}
case 'ADD_ARRAY_ITEM_LAST': {
  const current = Array.isArray(state[action.payload.field])
    ? (state[action.payload.field] as unknown[] || [])
    : [];

  return {
    ...state,
    [action.payload.field]: [...current, action.payload.item],
  };
}

case 'UPDATE_ARRAY_ITEM': {
  const current = Array.isArray(state[action.payload.field])
    ? (state[action.payload.field] as unknown[] || [])
    : [];
  return {
    ...state,
    [action.payload.field]: (current as unknown[]).map((item, i) =>
      i === action.payload.index
        ? typeof action.payload.value === 'function'
          ? action.payload.value(item)
          : action.payload.value
        : item
    ),
  };
}

case 'CLEAR_ARRAY': {
  return {
    ...state,
    [action.payload.field]: [],
  };
}

case 'DELETE_ARRAY_ITEM': {
  const current = Array.isArray(state[action.payload.field])
    ? (state[action.payload.field] as unknown[] || [])
    : [];
  return {
    ...state,
    [action.payload.field]: (current as unknown[]).filter((_, i) => i !== action.payload.index),
  };
}

      case 'HYDRATE':
        return { ...action.payload };

      case 'CLEAR_STATE':
        return {
          ...initialState,
          ...action.payload,
        };

      default:
        return state;
    }
  };
}